import { forwardRef } from "react";
import { clsx } from "clsx";

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'neutral' | 'info' | 'positive' | 'secondary' | 'primary' | 'caution' | 'success';
}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'neutral', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          // Base styles
          "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
          // Color variants using design system
          {
            "bg-muted text-muted-foreground border border-border": variant === 'neutral' || variant === 'secondary',
            "bg-info/20 text-info-foreground border border-info/20": variant === 'info',
            "bg-primary/20 text-primary border border-primary/20": variant === 'primary',
            "bg-positive/20 text-positive-foreground border border-positive/20": variant === 'positive' || variant === 'success',
            "bg-caution/20 text-caution-foreground border border-caution/20": variant === 'caution',
          },
          className
        )}
        {...props}
      />
    );
  }
);

Badge.displayName = "Badge";

export { Badge };